module.exports = __webpack_public_path__ + "static/media/schody32 - schody drewniane zabiegowe.658e7aef.jpg";